// extracted by mini-css-extract-plugin
module.exports = {"container":"imagePlaceholder_container__2yEXi","text":"imagePlaceholder_text__3FW0G","warning":"imagePlaceholder_warning__2mUmd","queue":"imagePlaceholder_queue__1eGza"};
    if(module.hot) {
      // 1783592057638
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  